<script>
import Layout from '@layouts/main.vue';
import CardProgramMinimal from '@components/cards/card-program-minimal.vue';
import SearchInput from '@components/search-input/search-input.vue';
import UseLargeScreen from '@components/use-large-screen.vue';
import SubheaderActions from '@components/subheader/subheader-actions.vue';
import { helperMixin } from '@mixins/helper-mixin';
import { cleverTapMixin } from '@mixins/cleverTap-mixin';
import { breakpointsMixin } from '@mixins/breakpoints-mixin.js';
import {
  authComputed,
  programComputed,
  programMethods,
  clientComputed,
  clientMethods,
  clientProgramMethods,
  organizationComputed,
} from '@state/helpers';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

export default {
  page: {
    title: 'Programs',
    meta: [{ name: 'description', content: 'The Programs page.' }],
  },
  components: {
    CardProgramMinimal,
    Layout,
    SearchInput,
    SubheaderActions,
    UseLargeScreen,
    Swiper,
    SwiperSlide,
  },
  mixins: [helperMixin, cleverTapMixin, breakpointsMixin],
  data() {
    return {
      initialProgramsList: null,
      selectedWeeks: [],
      isFiltering: false,
      isLoadingPrograms: false,
      searchComponentKey: 0,
      searchOpts: { keys: ['label'] },
      swiperOptions: {
        mousewheel: true,
        spaceBetween: 10,
        slidesPerView: 'auto',
        // Some Swiper option/callback...
      },
    };
  },
  computed: {
    ...authComputed,
    ...programComputed,
    ...clientComputed,
    ...organizationComputed,
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
    featurePrograms() {
      if (this.allPrograms && this.allPrograms.length > 0) {
        const filteredPrograms = this.allPrograms.filter((program) => {
          if (program && program.trainer_id && program.trainer_id === '0') {
            return program;
          }
        });
        return filteredPrograms;
      } else {
        return this.allPrograms;
      }
    },
    myPrograms() {
      if (this.allPrograms && this.allPrograms.length > 0) {
        const filteredPrograms = this.allPrograms.filter((program) => {
          if (program && program.trainer_id && program.trainer_id !== '0') {
            return program;
          }
        });
        return filteredPrograms;
      } else {
        return this.allPrograms;
      }
    },
    noResults() {
      return {
        title: this.isFiltering
          ? `We couldn't find any results that match your filter. Try changing your filter. Or, if you need to create a new program, you can go ahead and do that, too.`
          : 'No programs available. Create your first program that can be assigned to a client.',
        description: this.isFiltering
          ? ''
          : 'Programs can be assigned to a client. After they are assigned to a client, they can be cusotmized to fit your clients needs.',
      };
    },
    isTrainer() {
      return (
        this.currentUser &&
        this.currentUser.roles &&
        this.currentUser.roles.isTrainer
      );
    },
  },
  async created() {
    if (!this.allPrograms || !this.allPrograms.length) {
      this.isLoadingPrograms = true;

      if (this.trainerId && this.allClient.length === 0) {
        await this.getAllClient({ trainerId: this.trainerId });
      }

      await this.getProgramModel({
        orgId: this.userOrgId,
        trainerId: this.trainerId ? this.trainerId : '0',
      });
      await this.getAllPrograms({
        orgId: this.userOrgId,
        trainerId: this.trainerId ? this.trainerId : '0',
      });
      this.isLoadingPrograms = false;
    }
    this.initialProgramsList = cloneDeep(this.allProgramsTrueSource);
  },
  mounted() {
    this.swiper.slideTo(3, 1000, false);
  },
  destroyed() {
    this.clearFilters();
  },
  methods: {
    ...programMethods,
    ...clientMethods,
    ...clientProgramMethods,
    async onCreateNewProgram() {
      this.clearFilters();
      const date = moment().toISOString();
      const userId = '0';
      const payload = {
        ...this.programModel,
        creation_date: date,
        org_id: this.userOrgId,
        trainer_id: this.trainerId || '0',
        user_id: userId,
      };
      await this.createNewProgram(payload)
        .then((res) => {
          if (res.data.success) {
            this.initialProgramsList = cloneDeep(this.allProgramsTrueSource);
            this.setSelectedProgram(res.data.program);
            this.toProgramDetail(
              this.selectedProgram._id,
              this.selectedProgram
            );

            if (
              this.currentUser &&
              this.currentUser.roles &&
              this.currentUser.roles.isTrainer &&
              res &&
              res.data.program
            ) {
              const program = res.data.program._id;
              const trainer = this.trainerEmail;
              this.$_pushCleverTapEvent('Create Program', { program, trainer });
            }
          }
        })
        .catch((e) => console.log(e));
    },
    async onDuplicateProgram(program) {
      const label = 'Copy'.concat(' ', program.label);
      const payload = {
        id: program._id,
        label: label,
      };
      await this.duplicateProgram(payload).then((res) => {
        if (res && res.status === 200) {
          this.initialProgramsList = cloneDeep(this.allProgramsTrueSource);
          this.setSelectedProgram(res.data.program);
          this.toProgramDetail(this.selectedProgram._id, this.selectedProgram);
          if (
            this.currentUser &&
            this.currentUser.roles &&
            this.currentUser.roles.isTrainer &&
            res &&
            res.data.program
          ) {
            const program = res.data.program._id;
            const trainer = this.trainerEmail;
            this.$_pushCleverTapEvent('Create Program', { program, trainer });
          }
        }
      });
    },
    async archiveProgram(program) {
      const programPayload = {
        programId: program._id,
        orgId: program.org_id,
        trainerId: program.trainer_id,
        userId: program.user_id,
        program: program,
      };
      if (
        programPayload.programId &&
        programPayload.trainerId &&
        programPayload.userId &&
        programPayload.program
      ) {
        await this.deleteProgram(programPayload)
          .then(async (res) => {
            if (res.success) {
              this.setSelectedProgram(null);
              this.setAllClientProgram([]);
              this.setHasUnsavedProgramChanges(false);
              if (
                this.currentUser &&
                this.currentUser.roles &&
                this.currentUser.roles.isTrainer &&
                programPayload.programId
              ) {
                const program = programPayload.programId;
                const trainer = this.trainerEmail;
                this.$_pushCleverTapEvent('Delete Program', {
                  program,
                  trainer,
                });
              }
            }
          })
          .catch((e) => console.error(e));
      }
    },
    toProgramDetail(programId, program) {
      this.$router
        .push({
          name: 'programDetail',
          params: { id: programId, program: program },
        })
        .catch(() => {});
    },
    onFilterResults(val) {
      if (val === '') {
        this.isFiltering = false;
      } else {
        this.isFiltering = true;
      }
      this.setAllPrograms(val);
    },
    async onRetryFilterPrograms(val) {
      if (val === '') {
        this.setAllPrograms(this.initialProgramsList);
      } else if (!this.allPrograms.length) {
        this.setAllPrograms(this.initialProgramsList);
      }
    },
    clearFilters() {
      this.isFiltering = false;
      this.setAllPrograms(this.initialProgramsList);
      this.searchComponentKey++;
      const inputWithLabel = document.getElementsByClassName(
        'input-icon-wrapper'
      )[0];
      if (inputWithLabel) {
        if (inputWithLabel.children.length > 1) {
          const inputElement = inputWithLabel.children[1].firstChild;
          inputElement.value = null;
        }
      }
      if (this.$refs && this.$refs.checkBox && this.$refs.checkBox.length) {
        this.$refs.checkBox.forEach((checkBox) => {
          checkBox.$el.children[0].firstChild.checked = false;
        });
      }
    },
  },
};
</script>

<template>
  <UseLargeScreen v-if="isSmallScreenView" />
  <Layout v-else>
    <div class="container-wrapper">
      <div class="content-wrapper">
        <div :class="{ 'featured-section': isTrainer && featurePrograms }">
          <SubheaderActions>
            <SearchInput
              :key="searchComponentKey"
              :square="true"
              :dark="true"
              :list="initialProgramsList"
              :options="searchOpts"
              @filter-results="onFilterResults"
              @retry-filter-items="onRetryFilterPrograms"
            />
            <BaseButton
              v-if="!isTrainer || !featurePrograms"
              type="button"
              class="btn-primary btn-round"
              @click="onCreateNewProgram"
            >
              <img
                src="@assets/images/icon-calendar.svg"
                class="invert-color"
              />
              Create New Program
            </BaseButton>
          </SubheaderActions>
          <h1 v-if="isTrainer && featurePrograms" class="feature-program-title"
            >Featured Programs</h1
          >
          <p v-if="isTrainer && featurePrograms" class="feature-description"
            >From The {{ organizationTitle }} Library</p
          >
          <Swiper
            ref="mySwiper"
            :options="swiperOptions"
            :class="isTrainer ? 'feaured-programs-carousel' : 'grid-cards'"
          >
            <SwiperSlide v-for="item in featurePrograms" :key="item._id">
              <CardProgramMinimal
                :program="item"
                @duplicate-program="onDuplicateProgram"
              />
            </SwiperSlide>
          </Swiper>
        </div>

        <div v-if="isTrainer" class="my-programs-container">
          <SubheaderActions>
            <h1 class="my-program-title">My Programs</h1>
            <BaseButton
              v-if="featurePrograms"
              type="button"
              class="btn-primary btn-round"
              @click="onCreateNewProgram"
            >
              <img
                src="@assets/images/icon-calendar.svg"
                class="invert-color"
              />
              Create New Program
            </BaseButton>
          </SubheaderActions>
          <div
            class="grid-cards program-list"
            v-if="myPrograms && myPrograms.length > 0"
          >
            <CardProgramMinimal
              v-for="item in myPrograms"
              :key="item._id"
              :program="item"
              @duplicate-program="onDuplicateProgram"
              @archive-program="archiveProgram"
            />
          </div>
        </div>
        <div
          v-if="
            !isFiltering &&
              allPrograms &&
              allPrograms.length === 0 &&
              !isLoadingPrograms
          "
          class="empty-message--large"
        >
          <h1>{{ noResults.title }}</h1>
          <p class="program-description">{{ noResults.description }}</p>
        </div>

        <div
          v-if="
            allPrograms &&
              allPrograms.length === 0 &&
              !isLoadingPrograms &&
              isFiltering
          "
          class="empty-state-container"
        >
          <h2>We couldn’t find what you’re looking for.</h2>
          <p
            >This program does not exist in the program library. If you want to
            use this program, you will need create it.</p
          >
          <div class="actions">
            <BaseButton
              type="button"
              class="btn-secondary btn-round"
              @click="clearFilters"
            >
              Clear Filter
            </BaseButton>
            <BaseButton
              type="button"
              class="btn-primary btn-round"
              @click="onCreateNewProgram"
            >
              <img
                class="invert-color"
                src="@assets/images/icon-calendar.svg"
              />
              Create New
            </BaseButton>
          </div>
        </div>

        <div class="loading-wrapper" v-if="isLoadingPrograms">
          <BaseLoadingSpinner />
        </div>

        <!-- <div v-if="isLoadingPrograms" class="empty-message--large">
          <h1>LOADING <BaseIcon name="sync" spin/></h1>
        </div> -->
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.empty-state-container {
  background: $color-white;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba($color-black-wo-rgb, 0.08);
  display: flex;
  flex-direction: column;
  margin-bottom: 3vh;
  margin-left: auto;
  margin-right: auto;
  margin-top: 5vh;
  padding: 6rem;
  text-align: center;
  width: 55%;
  p {
    margin-top: 2rem;
  }
  .actions {
    align-items: center;
    display: flex;
    justify-content: center;
    margin-top: 2rem;
    ::v-deep .button {
      height: 3.7rem;
      padding-bottom: 0.2rem;
      padding-top: 0.2rem;
      white-space: nowrap;
    }
    ::v-deep .button.btn-secondary {
      margin-right: 10px;
    }
  }
}
.loading-wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 5em;
  width: 100%;
  ::v-deep .loading {
    height: 4rem;
    width: 4rem;
  }
}

.featured-section {
  background: $color-dark-gray-one;
  height: 45rem;
  margin: -3.2rem;
  margin-bottom: 0;
  padding: 3em;
}

.my-programs-container {
  padding-top: 4rem;
}

.program-list {
  // height: 30vh;
  height: 100%;
  // margin-bottom: 8rem;
  margin-bottom: 0;
  // margin-top: 3rem;
  margin-top: 0;
  max-height: 100%;
  // max-height: 30vh;
  min-height: 30vh;
}

.grid-cards {
  @include grid-cards(0.8, 24);
}

// stylelint-disable selector-max-type

p.program-description {
  font-size: 1.7rem;
  margin: 0 auto;
  width: 80%;
}

h1.my-program-title {
  margin-bottom: 0;
  margin-top: 0;
}

h1.feature-program-title {
  color: $color-off-white;
  margin-bottom: 0;
  margin-top: 5rem;
}

p.feature-description {
  color: $color-off-white;
  font-size: 2.1rem;
}

.feaured-programs-carousel {
  display: grid;
  gap: 0.8rem;
  // the '3' should be the number of cards, '30rem' is card width
  grid-template-columns: repeat(3, 30rem);
  padding: 2em;
  scroll-behavior: smooth;
}
::v-deep .content-wrapper {
  .search-input-wrapper {
    width: 60%;
  }
  .square {
    .input-icon-wrapper {
      .input {
        border-radius: 10rem;
        outline: none;
      }
    }
  }
}
.swiper-container {
  overflow: visible;
}
.swiper-slide {
  transition: 250ms all;

  &:hover {
    margin-top: -7rem;
    transform: scale(1.075);
    vertical-align: middle;
    z-index: 10;
  }
}
@media screen and (max-width: 888px) {
  .content-wrapper {
    .btn-primary {
      font-size: 1.1rem;
      padding-left: 1rem;
      padding-right: 1rem;
      width: 17rem;
    }

    img {
      width: 1.4rem;
    }
  }
}
</style>
